import { memo } from "react";
import styles from "./Status.module.scss";
import cn from "classnames";
import Icon from "../Icon/Icon";
import { STATUSES_TITLE } from "@services/getMinerList";
import { MINER_STATUSES_E } from "@constants/MinerStatuses";
import { useLocale } from "@utils/hooks/useLocale";
import { Tooltip } from "antd";
import { getDevivedHash } from "@utils/hash.utils";

import off from "@assets/icons/off.svg";
import ok from "@assets/icons/ok.svg";
import low from "@assets/icons/low.svg";
import bad from "@assets/icons/bad.svg";
import paused from "@assets/icons/paused.svg";
import stoped from "@assets/icons/stop.svg";
import broken from "@assets/icons/broken.svg";
import { IPoolCreds } from "@services/getSettings";

export interface StatusPropsI {
  readonly className?: string;
  readonly status: MINER_STATUSES_E;
  readonly admin_mining?: boolean;
  readonly crop?: boolean; // сокращение статуса словестного до 1 буквы
  readonly speed?: number;
  readonly iconShift?: number;
}

function Status({
  className,
  status,
  admin_mining,
  crop,
  speed,
  iconShift,
}: StatusPropsI) {
  const { locale } = useLocale();

  const icons = {
    //[MINER_STATUSES_E.UNKNOWN]: ,
    [MINER_STATUSES_E.OK]: ok,
    [MINER_STATUSES_E.LOW]: low,
    [MINER_STATUSES_E.BAD]: bad,
    //[MINER_STATUSES_E.STARTING]: ,
    [MINER_STATUSES_E.PAUSED]: paused,
    [MINER_STATUSES_E.STOPPED]: stoped,
    //[MINER_STATUSES_E.FAIL]: ,
    [MINER_STATUSES_E.OFF]: off,
    //[MINER_STATUSES_E.WARNING]: ,
    //[MINER_STATUSES_E.PENDING]: ,
    ///[MINER_STATUSES_E.STOPPING]: ,
  };

  if (
    [
      MINER_STATUSES_E.STOPPED,
      MINER_STATUSES_E.PAUSED,
      MINER_STATUSES_E.FAIL,//CONNECTION_ERROR,
      MINER_STATUSES_E.STARTING,
      MINER_STATUSES_E.STOPPING,
      // скорее всего надо добавить OFF статус
    ].indexOf(status) > -1
  ) {
    return (
      <div
        className={cn(styles.wrapper, className, {
          [styles.paused]: status === MINER_STATUSES_E.PAUSED,
          [styles.stoped]:
            status === MINER_STATUSES_E.STOPPED ||
            status === MINER_STATUSES_E.STOPPING,
          [styles.starting]: status === MINER_STATUSES_E.STARTING,
          [styles.connection_error]:
            status === MINER_STATUSES_E.FAIL, //CONNECTION_ERROR,
          [styles.crop]: crop,
        })}
        title={STATUSES_TITLE[status]}
        style={
          !!iconShift ? { transform: `translateY(${iconShift}px)` } : undefined
        }
      >
        {crop ? STATUSES_TITLE[status][0] : STATUSES_TITLE[status]}
      </div>
    );
  }

  return (
    <Tooltip
      open={!!speed ? undefined : false}
      title={<p className={styles.speed}>{getDevivedHash(speed)}</p>}
    >
      <Icon
        className={cn(className, {
          [styles.admin_mining]: admin_mining,
          [styles.status]: locale === "RU",
        })}
        src={icons[`${status as unknown as keyof typeof icons}`]}
        title={STATUSES_TITLE[status]}
        noHover
      />
    </Tooltip>
  );
}

function getPoolSettingStatus(pools: IPoolCreds[]): MINER_STATUSES_E.OK | MINER_STATUSES_E.LOW | MINER_STATUSES_E.BAD | MINER_STATUSES_E.OFF {
  const working = pools.filter(p =>
    p.status === MINER_STATUSES_E.OK ||
    p.status === MINER_STATUSES_E.LOW
  ).length;
  if (pools.length > 0) { // 1,2,3 
    if (working === pools.length) return MINER_STATUSES_E.OK;
    if (working >= 1 && pools.length > 1) return MINER_STATUSES_E.LOW;
    if (working === 1) return MINER_STATUSES_E.BAD;
  }
  return MINER_STATUSES_E.OFF;
}

function SettingPoolsStatus({
  pools,
  speed,
  className,
  admin_mining,
  size = "normal"
}: {
  pools: IPoolCreds[];
  speed?: number;
  className?: string;
  admin_mining?: boolean;
  size?: "small" | "normal" | "large"
}): JSX.Element {

  const { locale } = useLocale();
  const status = getPoolSettingStatus(pools);
  const icon = status === MINER_STATUSES_E.OK
    ? ok : status === MINER_STATUSES_E.LOW
      ? low : off;

  return (
    <Tooltip
      open={!!speed ? undefined : false}
      title={<p className={styles.speed}>{getDevivedHash(speed)}</p>}
    >
      <Icon
        className={cn(className, {
          [styles.admin_mining]: admin_mining,
          [styles.status]: locale === "RU",
        })}
        src={icon}
        title={STATUSES_TITLE[status]}
        noHover
      />
    </Tooltip>
  );
};

export { SettingPoolsStatus };
export default memo(Status);
